




















import { CreateElement, VNode } from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwStatusInfo } from '../sw-status-info';
import { messageManager } from './message-manager';
import { MessageDescriptor } from './types';

@Component({
  components:{
    SwStatusInfo,
  },
})
export default class SwMessageContainer extends SwExtendedVue{
  @Prop({ type: String, required: true })
  id: string;

  @Prop({ type: [Boolean, Number], default: false })
  autoHide: boolean | number;

  messageBuffer: MessageDescriptor[] = [];
  autoHideTimer: NodeJS.Timer | null = null;

  onMessageCallback(message: MessageDescriptor) {
    this.messageBuffer.push(message);
  }

  handleCloseRequest(md: MessageDescriptor) {
    const index = this.messageBuffer.indexOf(md);
    if (index >= 0) {
      this.messageBuffer.splice(index, 1);
    }
  }

  @Watch('autoHide')
  @Watch('messageBuffer')
  setupAutoHideTimer() {
    if (this.autoHide && this.messageBuffer.length > 0) {
      if (!this.autoHideTimer) {
        this.autoHideTimer = setInterval(
          () => {
            this.messageBuffer.shift();
          },
          typeof this.autoHide === 'number' ? this.autoHide : 3000,
        );
      }
    } else {
      if (this.autoHideTimer) {
        clearInterval(this.autoHideTimer);
        this.autoHideTimer = null;
      }
    }
  }

  render(h: CreateElement): VNode {
    const messageBoxesNodes: JSX.Element[] = [];

    this.messageBuffer.forEach((md) => {
      let messageNode: VNode | VNode[] | null = null;
      let messageProp: string | string[] | undefined = undefined;
      if (typeof md.message === 'function') {
        messageNode = md.message(h);
      } else {
        messageProp = md.message;
      }

      const messageBox = (
        <div key={md.uuid} class={['sw-message-container__list__box', 'sw-flexbox__flex-none']}>
          <sw-status-info
            name={md.type}
            message={messageProp}
            onClose={() => { this.handleCloseRequest(md); }}
          >{messageNode}</sw-status-info>
        </div>
      );

      messageBoxesNodes.push(messageBox);
    });

    const rootNode = (
      <div class={['sw-message-container']}>
        <transition-group
          tag="div"
          name="sw-list-fade"
          class={['sw-message-container__list', 'sw-flexbox', 'sw-flexbox--column']}
        >
          {messageBoxesNodes}
        </transition-group>
      </div>
    );

    return rootNode as VNode;
  }

  created() {
    messageManager.registerContainer(this.id, this.onMessageCallback);
  }

  beforeDestroy() {
    if (this.autoHideTimer) {
      clearInterval(this.autoHideTimer);
      this.autoHideTimer = null;
    }
    messageManager.unregisterContainer(this.id);
  }
}
